import {useEffect, useState} from "react";
import httpClient from "../api/httpClient";

// custom hook for performing GET request
const useFetch = (url, initialValue, params = {}, auto = true) => {
  const [data, setData] = useState(initialValue);
  const [loading, setLoading] = useState(true);

  const fetchData = async function () {
    try {
      setLoading(true);
      const response = await httpClient.get(url, {params: params});
      if (response.status === 200) {
        setData(response.data);
      }
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if(auto) fetchData();
  }, [url]);

  return {loading, data, fetchData};
};

export default useFetch;
